import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);


export const constantRoutes = [
  {
    path: "/",
    name: "GenerateAI",
    component: () => import("@/views/GenerateAI"),
    children: [
      {
        path: '/',
        name: 'GenerateList',
        component: () => import("@/views/GenerateAI/generateList.vue"),
        meta: {
          title: "AI生图平台",
          icon: "",
          keepAlive: true
        },
      },
      {
        path: "/GeneratePattern",
        name: "GeneratePattern",
        component: () => import("@/views/GeneratePattern/index.vue" +
        ""),
        meta: {
          title: "爆款图案",
          icon: ""
        },
      },
      {
        path: "/inpainter",
        name: "ai-inpainter",
        component: () => import("@/views/Tools"),
        meta: {
          title: "局部重绘",
          icon: "",
        },
      },
      {
        path: "/paint",
        name: "paint",
        component: () => import("@/views/toolkit/paint.vue"),
        meta: {
          title: "涂抹编辑",
          icon: "",
        },
      },
      {
        path: "/aiGoods",
        name: "aiGoods",
        component: () => import("@/views/aiGoods"),
        meta: {
            title: "模特与场景图",
            icon: "",
        },
    },
      
      {
        path: "/collect",
        name: "Collect",
        component: () => import("@/views/GenerateAI/collect"),
        meta: {
          title: "AI生图平台",
          icon: "",
        },
      },
      {
        path: "/BackgroundRedrawing",
        name: "BackgroundRedrawing",
        component: () => import("@/views/toolkit/BackgroundRedrawing.vue"),
        meta: {
          title: "更换背景"
        }
      },
      {
        path: "/amplify",
        name: "amplify",
        component: () => import("@/views/toolkit/amplify.vue"),
        props: true,
        meta: {
          title: "无损放大"
        }
      },
      {
        path: "/3dmodel",
        name: "3dmodel",
        component: () => import("@/views/toolkit/3dmodel.vue"),
        meta: {
          title: "转3D模型"
        }
      },
      {
        path: "/superZoom",
        name: "superZoom",
        component: () => import("@/views/toolkit/superZoom.vue"),
        meta: {
          title: "超级放大"
        }
      },
      {
        path: "/convert",
        name: "convert",
        component: () => import("@/views/toolkit/convert.vue"),
        meta: {
          title: "转换格式"
        }
      },
      {
        path: "/matting",
        name: "matting",
        component: () => import("@/views/toolkit/matting.vue"),
        meta: {
          title: "背景移除"
        }
      },
      {
        path: "/expand",
        name: "expand",
        component: () => import("@/views/toolkit/expand.vue"),
        meta: {
          title: "智能扩图"
        }
      },
      {
        path: "/enhanceImage",
        name: "enhanceImage",
        component: () => import("@/views/toolkit/enhanceImage.vue"),
        meta: {
          title: "画质增强"
        }
      },
      {
        path: "/instruction",
        name: "instruction",
        component: () => import("@/views/toolkit/instruction.vue"),
        meta: {
          title: "指令编辑"
        }
      },
      {
        path: "/fusion",
        name: "fusion",
        component: () => import("@/views/toolkit/fusion.vue"),
        meta: {
          title: "智能融图"
        }
      },
      {
        path: "/lineart",
        name: "lineart",
        component: () => import("@/views/toolkit/lineart.vue"),
        meta: {
          title: "线稿渲染"
        }
      },
      {
        path: "/operationVideo",
        name: "operationVideo",
        component: () => import("@/views/operationVideo"),
        meta: {
          title: "操作指南"
        }
      },
      {
        path: "/productPlanning",
        name: "productPlanning",
        component: () => import("@/views/productPlanning"),
        meta: {
          title: "产品策划"
        }
      },
    ]
  },

  {
    path: "/pointDescription",
    name: "PointDescription",
    component: () => import("@/views/pointDescription"),
    meta: {
      title: "消耗点数说明",
      icon: "",
    },
  },
  {
    path: "/show3dModel",
    name: "show3dModel",
    component: () => import("@/views/show3dModel"),
    meta: {
      title: "转3d查看",
      icon: "",
    },
  },
  {
    path: "/404",
    meta: {
      title: "Not Found"
    },
    component: () => import("@/views/404"),
    hidden: 3
  },
];




// 创建路由实例
const createRouter = () =>
  new VueRouter({
    // mode: 'history', // 启用的话就是去除#
    scrollBehavior: () => ({ y: 0 }),

    routes: constantRoutes
  });

let router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // 重置路由
}
router.afterEach((to, from) => {
  store.commit('SET_CURRENTTAB',to.name)
});
export default router;
